import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  get configFieldsTarget() {
    return $(this.element).find("[data-timesheets-membership-config-form-target='configFields']")
  }

  get templateSelectTarget() {
    return $(this.element).find("[data-timesheets-membership-config-form-target='templateSelect']")[0]
  }

  get warningMessageTarget() {
    return $(this.element).find("[data-timesheets-membership-config-form-target='warningMessage']")[0]
  }

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const templateSelected = Boolean(this.templateSelectTarget.value)

    this.configFieldsTarget.find("input").prop("disabled", templateSelected)
    this.configFieldsTarget.find("select").prop("disabled", templateSelected)
    this.configFieldsTarget.find("textarea").prop("disabled", templateSelected)
    this.configFieldsTarget.find("button").prop("disabled", templateSelected)

    this.warningMessageTarget.classList.toggle("d-none", !templateSelected)
  }
}
